import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const ContactFields = ({ value, onChange, withCompany = false, prefix }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const field = (key, label, props = {}) => (
    <div className="space-y-1.5">
      <Label htmlFor={`${prefix}-${key}`} className="text-slate-700">{label}</Label>
      <Input id={`${prefix}-${key}`} value={value[key] || ""} onChange={set(key)}
        className="border-amber-200 focus:border-amber-400" data-testid={`${prefix}-${key}-input`} {...props} />
    </div>
  );
  return (
    <div className="space-y-3">
      {withCompany && field("company_name", "Company name *", { maxLength: 120, placeholder: "e.g. Harbourview Developments" })}
      {field("name", withCompany ? "Contact name *" : "Name *", { maxLength: 120 })}
      {field("email", "Email *", { type: "email" })}
      {field("mobile", "Mobile", { type: "tel", maxLength: 30, placeholder: "04xx xxx xxx" })}
    </div>
  );
};
